/* CE:SP_SORT_AVAILABLE - disponibles avant vendues (profils vendeurs + page maison) */
(function(){
  var p=location.pathname;
  if(p.indexOf("seller-profile")<0 && p.indexOf("/pages/collectorelysium")<0)return;
  var SEL=[".seller_product_grid",".ce-sp-grid"];
  function aProduit(c){
    if(!c.getElementsByTagName)return false;
    if(c.tagName==="A"){var h0=c.getAttribute("href")||"";if(h0.indexOf("/products/")>-1)return true;}
    var a=c.getElementsByTagName("a");
    for(var i=0;i<a.length;i++){
      var h=a[i].getAttribute("href")||"";
      if(h.indexOf("/products/")>-1)return true;
    }
    return false;
  }
  function estVendu(el){
    var c=" "+(el.className||"")+" ";
    if(c.indexOf(" ce-sold ")>-1||c.indexOf(" sold ")>-1)return true;
    var t=(el.textContent||"").toUpperCase();
    return t.indexOf("SOLD")>-1||t.indexOf("VENDU")>-1;
  }
  function trierGrille(g){
    var cards=[];var enf=g.children;
    for(var i=0;i<enf.length;i++){ if(aProduit(enf[i])) cards.push(enf[i]); }
    if(cards.length<2)return;
    var d=[],v=[];
    for(var k=0;k<cards.length;k++){ (estVendu(cards[k])?v:d).push(cards[k]); }
    if(!v.length)return;
    var actuel="",voulu="";
    for(var m=0;m<cards.length;m++){ actuel+=estVendu(cards[m])?"V":"D"; }
    for(var q=0;q<d.length;q++){ voulu+="D"; }
    for(var s=0;s<v.length;s++){ voulu+="V"; }
    if(actuel===voulu)return;
    var ordre=d.concat(v);
    for(var z=0;z<ordre.length;z++){ g.appendChild(ordre[z]); }
  }
  function trier(){
    var trouve=false;
    for(var i=0;i<SEL.length;i++){
      var gs=document.querySelectorAll(SEL[i]);
      for(var k=0;k<gs.length;k++){ trouve=true; trierGrille(gs[k]); }
    }
    return trouve;
  }
  trier();
  var n=0,iv=setInterval(function(){ trier(); if(++n>60) clearInterval(iv); },300);
  if(window.MutationObserver){
    var mo=new MutationObserver(function(){ trier(); });
    mo.observe(document.body,{childList:true,subtree:true});
    setTimeout(function(){ mo.disconnect(); },60000);
  }
})();